// extracted by mini-css-extract-plugin
module.exports = {"form":"search_form__3i4FL","input":"search_input__1RE6U"};